'use strict';

/**
 * @class
 * Example use:
 * 	var resizeDebouncer = new Debouncer(callbackFn);
 *  window.addEventListener('resize', resizeDebouncer.run, false);
 *
 * Or, if using JQuery (but you can also
 * 	var resizeDebouncer = new Debouncer(callbackFn);
 *  $(window).bind('resize', resizeDebouncer.run);
 *
 * Or, all on one line:
 *  $(window).bind('resize', (new Debouncer(callbackFn)).run);
 *
 *  @param {function} callback
 *  @param {boolean} [immediate=false] - If `immediate` is set to true, the callback function is called on the leading edge and at the end of the interval if an event happens since first event but not during waiting period. If false, called at the end of each interval and not at the start.
 *  @param {number} [wait] - The interval in ms to use to debounce. If not specified, the debouncer uses requestAnimationFrame.
 */
function Debouncer(callback, immediate, wait) {
	var self = this;

	this._callback = callback;
	this._immediate = immediate;
	this._timeout = wait;

	this._waitingID = null;

	this._laterFn = function() {
		self._waitingID = null;
		if (self._immediate !== true || self._immediateSkipped === true) {
			self._immediateSkipped = null;
			self._callback.apply(self._callbackThis, self._callbackArgs);
		}
	}

	/**
	 * This will run the callback provided during construction of a Debouncer.
	 * Any passed arguments to run(...) will be passed to the callback.
	 * Calls are debounced using requsetAnimationFrame.
	 * @public
	 */
	this.run = function() {
		_run(self, this, arguments);
	};
}

/**
 * @private
 */
function _run(debouncer, thisArg, args) {
	debouncer._callbackThis = thisArg;
	debouncer._callbackArgs = args;

	if (debouncer._immediate === true) {
		if (debouncer._waitingID === null) {
			// Call now (if set to immediate and not waiting).
			debouncer._immediateSkipped = false;
			debouncer._callback.apply(debouncer._callbackThis, debouncer._callbackArgs);
		} else {
			debouncer._immediateSkipped = true;
		}
	}

	if (debouncer._waitingID === null) {
		if (debouncer._timeout === undefined) {
			debouncer._waitingID = requestAnimationFrame(debouncer._laterFn);
		} else {
			debouncer._waitingID = setTimeout(debouncer._laterFn, debouncer._timeout);
		}
	}
}

/**
 * Run the callback method immediately without debouncing.
 * Any active debouncing is canceled first.
 * @public
 */
Debouncer.prototype.runNow = function() {
	this.cancel();
	this._callback.apply(this, arguments);
}
/**
 * Cancel a call to 'run'.
 * @public
 */
Debouncer.prototype.cancel = function() {
	if (this._timeout === undefined) {
		cancelAnimationFrame(this._waitingID);
	} else {
		clearTimeout(this._waitingID);
	}
	this._waitingID = null;
}

module.exports = Debouncer;
